import React from 'react';
import PropTypes from 'prop-types';
import { NoDataText, ListItem, withLiveChannelsService } from 'LocalGluons';
import { noop } from 'Utils';
import { ProgramModel } from '@24i/st-api-connector';
import { withStore } from 'Store';
import { filterOutAdultItemsByCategories } from 'Utils/parentalControlUtils';
import { Device } from 'DeviceUtils';
import { FlashList } from '@shopify/flash-list';
import { DEFAULT_TV_LIST_WEB_LIMIT, DEFAULT_TV_LIST_LIMIT } from 'Options';
import styles from './NowOnTvList.jss';

// const BOTTOM_OFFSET = 40;

export const DEFAULT_LIST_MODE = 'live';

// const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) =>

const modeledItems = (channels) =>
    channels.map((item) => ({
        ...item,
        live: new ProgramModel(item.live),
        next: new ProgramModel(item.next),
        // Extend model with this method required for parental check
        getChannelId: () => item.channel.channelId
    }));

class NowOnTvList extends React.PureComponent {
    constructor(props) {
        const { channels, categories, parentalLockConfig, highlightedItemId } = props;
        const items = filterOutAdultItemsByCategories(
            modeledItems(channels),
            categories,
            parentalLockConfig
        );
        super(props);
        this.flatListRef = {};
        this.wasScrolledByUser = false;

        this.state = {
            items,
            selectedIndex: items.findIndex((x) => x.live.getId() === highlightedItemId)
        };
    }

    componentDidMount() {
        this.fetchData();
        // this.checkFilterActive();
    }

    //**This check wil take only category filtered to display an does not show other channels, but when checked "Favorites toggle",
    // it will display only favorites channel from current category so it can also display empty component. Update function and remove all calls if want to enhance it*/
    // checkFilterActive = () => {
    //     const { epgFilters } = this.props;
    //     if (epgFilters && epgFilters.length > 0) {
    //         const { items } = this.state;
    //         console.log('11111111111', items.length);
    //         const filteredItems = items.filter((item) =>
    //             epgFilters.some((filter) =>
    //                 filter.channels.some(
    //                     (filterChannel) => filterChannel.channelId === item.channel.channelId
    //                 )
    //             )
    //         );
    //         console.log('22222222222', this.props,filteredItems.length);
    //         this.setState({ items: filteredItems });
    //     }
    // };

    async componentDidUpdate(prevProps, prevState) {
        const {
            hidden,
            highlightedItemId,
            channels,
            setKeptMiniEpgScrollIndex,
            keptMiniEpgScrollIndex,
            passedItemData,
            blockScrollLoading
        } = this.props;
        const { items } = this.state;
        if (hidden && prevProps.hidden === true) {
            await this.fetchData();
        }
        const check = items?.findIndex((x) => x.live.getId() === passedItemData?.data?.id);
        if (prevProps.keptMiniEpgScrollIndex !== check) {
            if (prevProps.keptMiniEpgScrollIndex !== -1 || check !== -1) {
                const validIndex = check === -1 ? prevProps.keptMiniEpgScrollIndex : check;
                setKeptMiniEpgScrollIndex(validIndex);
                this.setState({
                    selectedIndex: validIndex
                });
            }
        }
        if (prevProps.keptMiniEpgScrollIndex !== keptMiniEpgScrollIndex) {
            this.setState({
                selectedIndex: keptMiniEpgScrollIndex
            });
        }

        if (prevProps.highlightedItemId !== highlightedItemId) {
            const selectedIndex = items?.findIndex((x) => x.live.getId() === highlightedItemId);
            this.setState({
                selectedIndex
            });
        }

        if (prevProps.channels !== channels && channels.length > 0) {
            this.setChannels();
        }

        if (!hidden && prevProps.hidden && this.wasScrolledByUser) {
            const selectedIndex = items?.findIndex((x) => x.live.getId() === highlightedItemId);
            this.flatListRef.scrollToIndex({ index: selectedIndex, animated: false });
        }
               if(prevProps.blockScrollLoading !== blockScrollLoading) {
                this.setState({
                    items:items
                });
        }
    }

    setChannels = () => {
        const {
            channels,
            categories,
            parentalLockConfig,
            highlightedItemId,
            keptMiniEpgScrollIndex,
        } = this.props;
        const { selectedIndex } = this.state;

        const items = filterOutAdultItemsByCategories(
            modeledItems(channels),
            categories,
            parentalLockConfig
        );
        this.setState(
            {
                items,
                selectedIndex: items?.findIndex((x) => x.live.getId() === highlightedItemId)
            },
            // this.checkFilterActive
        );

        if (selectedIndex === -1) {
            this.setState({
                selectedIndex: keptMiniEpgScrollIndex
            });
        }
    };

    fetchData = async () => {
        const { getChannels } = this.props;

        await getChannels(
            {
                list: 'live',
                limit: 0
            },
            undefined,
            undefined,
            false,
            true
        );
        // this.checkFilterActive();
    };

    fetchDataWithOffset = async (
        offset,
        limit = Device.isWeb ? DEFAULT_TV_LIST_WEB_LIMIT : DEFAULT_TV_LIST_LIMIT
    ) => {
        const { getChannels, channelsAreLoading, channelsFetchErrored } = this.props;
        if (!channelsAreLoading && !channelsFetchErrored) {
            // TODO: count on totalCount, do not download overlap data
            const params = {
                list: DEFAULT_LIST_MODE,
                offset,
                limit
            };
            await getChannels(params);
        }
    };

    render() {
        const {
            children,
            style,
            channelsAreLoading,
            channelsEndReached,
            blockScrollLoading,
            onSelectChannel,
            onSelectProgram,
            highlightedItemId,
            parentalLockConfig,
            genreDataHide,
            keptMiniEpgScrollIndex
        } = this.props;
        const { items, selectedIndex } = this.state;

        const itemsLength = items?.length;
        const itemsExist = itemsLength > 0;
        return (
            <>
                {children}
                <FlashList
                    data={items}
                    renderItem={({ item: { channel, live, next } }) => (
                        <ListItem
                            channel={channel}
                            liveItem={live}
                            nextItem={next}
                            parentalLockConfig={parentalLockConfig}
                            onSelectChannel={onSelectChannel}
                            onSelectProgram={onSelectProgram}
                            isHighlighted={highlightedItemId === live.getId()}
                            genreDataHide={genreDataHide}
                        />
                    )}
                    estimatedItemSize={styles.itemContainer.height}
                    estimatedFirstItemOffset={0}
                    initialScrollIndex={keptMiniEpgScrollIndex}
                />
                {/* <FlatList
                    initialScrollIndex={selectedIndex}
                    onScroll={({ nativeEvent }) => {
                        this.wasScrolledByUser = true;
                        if (
                            !Device.isWeb &&
                            isCloseToBottom(nativeEvent) &&
                            !channelsEndReached &&
                            !blockScrollLoading
                        ) {
                            this.fetchDataWithOffset(itemsLength);
                        }
                    }}
                    scrollEventThrottle={THROTTLE_TIME}
                    contentContainerStyle={[styles.container, style]}
                    ref={(ref) => {
                        this.flatListRef = ref;
                    }}
                    data={items}
                    renderItem={({ item: { channel, live, next } }) => (
                        <ListItem
                            key={channel.channelId}
                            channel={channel}
                            liveItem={live}
                            nextItem={next}
                            parentalLockConfig={parentalLockConfig}
                            onSelectChannel={onSelectChannel}
                            onSelectProgram={onSelectProgram}
                            isHighlighted={highlightedItemId === live.getId()}
                            genreDataHide={genreDataHide}
                        />
                    )}
                    getItemLayout={(data, index) => ({
                        length: styles.itemContainer.height,
                        offset: styles.itemContainer.height * index,
                        index
                    })}
                    removeClippedSubviews={true}
                    maxToRenderPerBatch={10}
                /> */}

                {/* <>
                        {children}
                        <View style={style.itemContainer}>
                            <ActivityIndicator style={{ flex: 1, paddingTop: '50%' }} />
                        </View>
                    </> */}
                {!channelsAreLoading && !itemsExist && <NoDataText style={styles.noDataText} />}
            </>
        );
    }
}

NowOnTvList.defaultProps = {
    children: [],
    style: {},
    onSelectChannel: noop,
    onSelectProgram: noop,
    highlightedItemId: null,
    hidden: false,
    blockScrollLoading: false,
    genreDataHide: false
};

NowOnTvList.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    style: PropTypes.shape({}),
    onSelectChannel: PropTypes.func,
    onSelectProgram: PropTypes.func,
    highlightedItemId: PropTypes.number,
    parentalLockConfig: PropTypes.shape({}).isRequired,
    hidden: PropTypes.bool,
    getChannels: PropTypes.func.isRequired,
    channelsAreLoading: PropTypes.bool.isRequired,
    channelsFetchErrored: PropTypes.bool.isRequired,
    channelsEndReached: PropTypes.bool.isRequired,
    blockScrollLoading: PropTypes.bool,
    refreshChannels: PropTypes.func.isRequired,
    genreDataHide: PropTypes.bool
};

export default withStore(withLiveChannelsService(NowOnTvList));
